export default __webpack_public_path__ + "static/media/banner_mob_amarelo_1.246bf469.jpg";